import {Nullish} from 'shared/web';

import {SourcingType} from '../../../hooks/useSourcingType';
import {VehicleCategoryFilter} from '../types/VehicleCategoryFilter';

/**
 * The vehicle category that actually filters the active tab.
 *
 * The filter state is shared by both tabs, so a category picked on classifieds is still set after
 * switching to auctions. `all_auctions` silently ignores `vehicle_type`, so there the category must
 * neither narrow the body style dropdown nor show up as an active filter tag.
 */
export const getAppliedVehicleCategory = (
  vehicleCategory: VehicleCategoryFilter | Nullish,
  sourcingType: SourcingType
): VehicleCategoryFilter | null =>
  sourcingType === SourcingType.CLASSIFIEDS ? (vehicleCategory ?? null) : null;
